import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { getPostLoginRoute } from "../utils/routeHelpers";

function OtpRecoveryVerify() {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const recovery = JSON.parse(
        sessionStorage.getItem("mistribazaarOtpRecovery") ||
          localStorage.getItem("mistribazaarOtpRecovery") ||
          "null"
      );

      if (!recovery) {
        throw new Error("No OTP recovery session found.");
      }

      let result;

      if (recovery.mode === "phone") {
        result = await supabase.auth.verifyOtp({
          phone: recovery.phone,
          token: otp,
          type: "sms",
        });
      } else {
        result = await supabase.auth.verifyOtp({
          email: recovery.email,
          token: otp,
          type: "email",
        });
      }

      if (result.error) throw result.error;
      if (!result.data.user) throw new Error("OTP verification failed.");

      sessionStorage.removeItem("mistribazaarOtpRecovery");
      localStorage.removeItem("mistribazaarOtpRecovery");

      const { data: profile, error: profileError } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", result.data.user.id)
        .single();

      if (profileError) throw profileError;

      navigate(getPostLoginRoute(profile));
    } catch (error) {
      console.error("Recovery verify error:", error);
      alert(error.message || "Failed to verify OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={page}>
      <div style={card}>
        <h1>Verify Recovery OTP</h1>
        <p style={{ color: "#d1d1d1" }}>
          Enter the OTP sent to your selected recovery channel.
        </p>

        <form onSubmit={handleVerify}>
          <input
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP"
            required
            style={input}
          />

          <button type="submit" disabled={loading} style={button}>
            {loading ? "Verifying..." : "Verify OTP"}
          </button>
        </form>
      </div>
    </div>
  );
}

const page = {
  background: "radial-gradient(circle at top, #101010 0%, #000 55%)",
  minHeight: "100vh",
  padding: "40px 20px",
  color: "#fff",
  fontFamily: "Arial, sans-serif",
};

const card = {
  maxWidth: "520px",
  margin: "0 auto",
  background: "#111",
  padding: "24px",
  borderRadius: "18px",
  border: "1px solid #2a2a2a",
};

const input = {
  width: "100%",
  padding: "12px 14px",
  marginBottom: "14px",
  borderRadius: "10px",
  border: "1px solid #2a2a2a",
  background: "#0b0b0b",
  color: "#fff",
  boxSizing: "border-box",
};

const button = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  background: "#fff",
  color: "#000",
  fontWeight: "bold",
  cursor: "pointer",
};

export default OtpRecoveryVerify;
